import clsx from "clsx";
import { Link } from "react-router-dom";

import { date, text, rightColHeader } from "../styles";
import { routesFlat } from "@routes";
import { RocketIcon } from "@assets/icons";

export default function Featured() {
    return (
        <>
            <div className={rightColHeader}>featured update</div>
            {/* TODO: replace with link newfeed URI */}
            <Link to="/news/june2026-jredd-webinar">
                <div className={clsx(date + " mt-2 tracking-wider")}>
                    May 28, 2026
                </div>
                <div className={clsx(text + " line-clamp-3")}>
                    Join CTrees for a webinar on June 18, Measuring What Matters: MRV for High-Integrity JREDD+.
                </div>
            </Link>

            <Link to="https://us06web.zoom.us/webinar/register/9017780085833/WN_Oou9Hb5iSPygAz0ZF0sRjw#/" target="_blank" className="mt-1 flex text-sm font-bold">
                <RocketIcon />
                <div className="ml-2 border-b-[1px] border-b-red">
                    Register
                </div>
            </Link>
        </>
    );
}
